import Controller from '@ember/controller';

export default class AuthenticatedPlaylistsIndexController extends Controller {}
